var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardAmexLarge = function SvgCardAmexLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "card-amex-large_svg__Layer_1",
    viewBox: "0 0 235 153"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".card-amex-large_svg__st0,.card-amex-large_svg__st1{fill:#fff;fill-rule:evenodd}.card-amex-large_svg__st1{fill:#016fd0}"))), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 153,
    rx: 16,
    ry: 16,
    style: {
      fill: "#016fd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.015 58.011c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm-20.735 4.51c0-.313.085-.62.246-.889l2.706-4.51a1.73 1.73 0 0 1 1.482-.839h12.269c.954 0 1.728.774 1.728 1.728v24.191c0 .954-.774 1.728-1.728 1.728H21.714a1.73 1.73 0 0 1-1.482-.839l-2.706-4.51a1.73 1.73 0 0 1-.246-.889v-15.17Zm33.983-6.238c-.954 0-1.728.774-1.728 1.728v12.672c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728V58.011c0-.954-.774-1.728-1.728-1.728h-5.76ZM38.015 72.987c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm13.248 1.728c-.954 0-1.728.774-1.728 1.728v5.76c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728v-5.76c0-.954-.774-1.728-1.728-1.728h-5.76Z",
    style: {
      fill: "#0185ff",
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 11.875h58.749v58.75H164.5v-58.75Z",
    className: "card-amex-large_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.785 61.33V40.278l37.468.035v5.815l-4.331 4.627 4.331 4.672v5.938h-6.914l-3.674-4.054-3.649 4.071-23.231-.05Z",
    className: "card-amex-large_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.287 59.02V42.594h13.929v3.784h-9.418v2.569h9.193v3.722h-9.193v2.523h9.418v3.829h-13.929Z",
    className: "card-amex-large_svg__st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m202.148 59.021 7.706-8.222-7.706-8.203h5.965l4.709 5.206 4.723-5.206h5.709v.129l-7.543 8.074 7.543 7.99v.232h-5.767l-4.792-5.258-4.744 5.258h-5.803Z",
    className: "card-amex-large_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.533 21.593h9.032l3.172 7.204v-7.204h11.15l1.923 5.397 1.929-5.397h8.514v21.051h-44.995l9.275-21.051Z",
    className: "card-amex-large_svg__st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m189.242 23.88-7.289 16.413h4.999l1.375-3.287h7.45l1.375 3.287h5.122l-7.258-16.413h-5.774Zm.626 9.443 2.185-5.225 2.184 5.225h-4.369Z",
    className: "card-amex-large_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.205 40.29V23.877l7.026.024 3.616 10.09 3.64-10.114h6.762V40.29l-4.351.038V29.054L214.79 40.29h-3.973l-4.193-11.275V40.29h-4.419Z",
    className: "card-amex-large_svg__st1"
  })));
};
export default SvgCardAmexLarge;